/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Quirk_HandlingInputs */

const en_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quirk handling`)
};

const ar_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معالجة الخصوصيات`)
};

const bn_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কুয়ার্ক হ্যান্ডলিং`)
};

const de_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenartige Handhabung`)
};

const es_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manejo de peculiaridades`)
};

const fr_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des bizarreries`)
};

const pt_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tratamento peculiar`)
};

const zh_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怪异处理`)
};

const tr_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuhaf kullanım`)
};

const ru_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка причуд`)
};

const pl_svchip_quirk_handling = /** @type {(inputs: Svchip_Quirk_HandlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dziwaczne postępowanie`)
};

/**
* | output |
* | --- |
* | "Quirk handling" |
*
* @param {Svchip_Quirk_HandlingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_quirk_handling = /** @type {((inputs?: Svchip_Quirk_HandlingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Quirk_HandlingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_quirk_handling(inputs)
	if (locale === "bn") return bn_svchip_quirk_handling(inputs)
	if (locale === "de") return de_svchip_quirk_handling(inputs)
	if (locale === "es") return es_svchip_quirk_handling(inputs)
	if (locale === "fr") return fr_svchip_quirk_handling(inputs)
	if (locale === "pt") return pt_svchip_quirk_handling(inputs)
	if (locale === "zh") return zh_svchip_quirk_handling(inputs)
	if (locale === "tr") return tr_svchip_quirk_handling(inputs)
	if (locale === "ru") return ru_svchip_quirk_handling(inputs)
	if (locale === "pl") return pl_svchip_quirk_handling(inputs)
	return en_svchip_quirk_handling(inputs)
});